import axios from 'axios';
import lazyLoader from '../modules/lazyLoader';
import log from './log';

interface ITemplateGetHTMLOptions {
  url: string,
  content: string,
  view?: string,
  sortBy?: string
}

interface ITemplateGetAndUpdateOptions extends ITemplateGetHTMLOptions {
  node: HTMLElement
}

class Template {
  getHTML(options:ITemplateGetHTMLOptions):Promise<string|undefined> {
    return new Promise(async (resolve, reject) => {
      let html;
      let response;

      if (options.view) {
        if (options.url.includes('?')) {
          options.url += `&view=${ options.view }`;
        } else {
          options.url += `?view=${ options.view }`;
        }
      }

      if (options.sortBy) {
        if (options.url.includes('?')) {
          options.url += `&sort_by=${ options.sortBy }`;
        } else {
          options.url += `?sort_by=${ options.sortBy }`;
        }
      }

      try {
        response = await axios({
          method: 'get',
          url: options.url,
          responseType: 'document'
        });
        if (response) html = response.data.querySelector(options.content).innerHTML;
      }
      catch(error) {
        reject(error);
      }
      
      resolve(html);
    });
  }

  async getAndUpdateHTML(options:ITemplateGetAndUpdateOptions) {
    try {
      options.node.innerHTML = await this.getHTML({
        url: options.url,
        content: options.content,
        view: options.view ? options.view : null
      });
      lazyLoader.update();
    }
    catch(error) {
      log.error(error);
    }
  }

  async getAndAppendHTML(options:ITemplateGetAndUpdateOptions) {
    try {
      options.node.insertAdjacentHTML('beforeend', await this.getHTML({
        url: options.url,
        content: options.content,
        view: options.view ? options.view : null,
        sortBy: options.sortBy ? options.sortBy : null
      }));
      lazyLoader.update();
    }
    catch(error) {
      log.error(error);
    }
  }
}

export default new Template();